<template>
  <v-sheet>
    <div class="d-flex">
      <v-img :src="image" max-height="50" max-width="180" />
      <v-btn
        data-testid="refresh-captcha"
        @click="refreshCaptcha"
        icon
        :disabled="readonly"
        :loading="refreshing"
      >
        <v-icon>mdi-refresh</v-icon>
      </v-btn>
    </div>
    <v-text-field
      filled
      label="Captcha"
      v-model="saisie"
      :disabled="refreshing"
      @keypress.enter.prevent="enter"
      :rules="[requiredRule(), serverRule('captcha')]"
      @input="notify('captcha')"
      data-testid="reponse-captcha"
    />
  </v-sheet>
</template>

<script>
import makeValueData from "@/mixins/makeValueData";
import makeRules from "@/mixins/makeRules";
import ValueDataRules from "@/mixins/ValueDataRules";

function mapTo(src, dest) {
  src = src || {};
  dest.captcha = src.captcha;
  dest.saisie = src.saisie;
}
import { captchaService } from "@/services";
export default {
  inject: ["form"],
  mixins: [makeValueData(mapTo), makeRules(), ValueDataRules],
  props: {
    service: {
      type: String,
      default: "api",
    },
  },
  data() {
    return {
      image: null,
      refreshing: false,
      urls: [],
    };
  },
  mounted() {
    this.refreshCaptcha();
  },
  destroy() {
    for (const u of this.urls) {
      URL.revokeObjectURL(u);
    }
  },
  computed: {
    readonly() {
      return this.form?.readonly || false;
    },
  },
  methods: {
    refreshCaptcha() {
      this.refreshing = true;
      captchaService
        .captcha(this.service)
        .then(c => {
          this.captcha = c.captcha;
          const url = URL.createObjectURL(c.image);
          this.image = url;
          this.urls.push(url);
          this.notify("captcha");
        })
        .finally(() => (this.refreshing = false));
    },
    enter() {
      this.$emit("enter");
    },
  },
};
</script>
